import Script from 'next/script';
import css from './index.module.scss';

// https://modelviewer.dev
export default function Model3D({ props, strategy, children }: any) {
    return (
        <div
            className={`${css.object3D} object-3d`}
            // style={{
            //     backgroundImage: `url('https://websiteoss.ecoflow.com/upload/image/1765529641582/university_workshop_1k.exr')`,
            //     backgroundSize: 'cover',
            //     backgroundPosition: 'center',
            // }}
        >
            {/* strategy: beforeInteractive(页面可交互前加载) | afterInteractive(页面可交互后加载)(default) | lazyOnload(页面空闲时加载) ｜ worker(web worker方式加载) ｜ undefined */}
            <Script strategy={strategy || 'lazyOnload'} type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js" />
            {/* @ts-ignore */}
            <model-viewer
                src={'/models/blade/blade_treaser.glb'}
                alt={'View in your space'}
                aria-label={'View in your space'}
                camera-controls
                disable-zoom // 禁用缩放
                disable-tap // 禁用点击
                loading="lazy"
                // exposure="0.5"
                // environment-image="neutral"
                // environment-image="https://websiteoss.ecoflow.com/upload/image/1765526527305/university_workshop_1k.hdr"
                // environment-image="https://websiteoss.ecoflow.com/upload/image/1765529641582/university_workshop_1k.exr"
                // background-image="https://websiteoss.ecoflow.com/upload/image/1765529641582/university_workshop_1k.exr"
                exposure="1.0"
                {...props}
            >
                {children}
                {/* @ts-ignore */}
            </model-viewer>
        </div>
    );
}
